import {Component, OnInit, Input, ElementRef, ViewChild} from '@angular/core'

@Component({
  selector: 'app-tabs',
  templateUrl: './tabs.component.html',
  styleUrls: ['./tabs.component.scss'],
})
export class TabsComponent implements OnInit {
  @Input() tabs
  @ViewChild('container') container
  current: string

  constructor(private elref: ElementRef) {}

  ngOnInit() {
    this.current =
      localStorage.getItem('tabs' + Object.keys(this.tabs).join('-')) ||
      Object.keys(this.tabs)[0]
    this.update(this.current)
  }

  update(tab) {
    localStorage.setItem('tabs' + Object.keys(this.tabs).join('-'), tab)
    this.current = tab
    let els = this.container.nativeElement.childNodes
    for (let i = 0; i < els.length; i++) {
      if (Object.keys(this.tabs).includes(els[i].id)) {
        if (els[i].id == this.current) els[i].style.display = 'flex'
        else els[i].style.display = 'none'
      }
    }
  }
}



// WEBPACK FOOTER //
// /Users/axel/Sites/Bannerboy/Internal/attaboy-angular/src/app/ui-shared/tabs/tabs.component.ts